var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Are you sure you want to pick "),_c('strong',[_vm._v(_vm._s(_vm.versionLabel))]),_vm._v(" as the winner and finish the split test? This will discard the other versions.")])])}
var staticRenderFns = []

export { render, staticRenderFns }